import { QueryResult, useQuery } from '@apollo/client'
import {
  OneOffPaymentAndObjectivePaymentsWithObjectivesAndTargetBonusAndContractChangesAndCurrentContractQuery,
  OneOffPaymentAndObjectivePaymentsWithObjectivesAndTargetBonusAndContractChangesAndCurrentContractQueryVariables,
  Country,
} from '../../../types'
import { ONE_OFF_PAYMENT_AND_OBJECTIVE_PAYMENTS_WITH_OBJECTIVES_AND_TARGET_BONUS_AND_CONTRACT_CHANGES_AND_CURRENT_CONTRACT } from '../OneOffPaymentQueries'

export default (
  employeeId: number,
  meetingId: number,
  year: number,
  newTargetsYear: number,
  country: Country,
  includeAllTargetBoni: boolean,
  includeGovernmentJobTitles = false,
): QueryResult<
  OneOffPaymentAndObjectivePaymentsWithObjectivesAndTargetBonusAndContractChangesAndCurrentContractQuery,
  OneOffPaymentAndObjectivePaymentsWithObjectivesAndTargetBonusAndContractChangesAndCurrentContractQueryVariables
> => {
  return useQuery<
    OneOffPaymentAndObjectivePaymentsWithObjectivesAndTargetBonusAndContractChangesAndCurrentContractQuery,
    OneOffPaymentAndObjectivePaymentsWithObjectivesAndTargetBonusAndContractChangesAndCurrentContractQueryVariables
  >(ONE_OFF_PAYMENT_AND_OBJECTIVE_PAYMENTS_WITH_OBJECTIVES_AND_TARGET_BONUS_AND_CONTRACT_CHANGES_AND_CURRENT_CONTRACT, {
    variables: {
      employeeId: employeeId,
      meetingId: meetingId,
      year,
      newTargetsYear,
      country,
      includeAllTargetBoni,
      includeGovernmentJobTitles,
    },
    fetchPolicy: 'network-only',
  })
}
